module.exports = __webpack_public_path__ + "img/profile.055d260a.jpg";